import { mq } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

// import { CheckSelectionFilters } from "./CheckSelectionFilters";//
import { PageTitle } from "../../../../../../components/page-title/PageTitle";

interface Props {
  onSearch: (searchTerm: string) => void;
}

export function CheckSelectionHeader(props: Props) {
  const { t } = useTranslation();
  // const { onSearch } = props;

  return (
    <div className={styles.headerContainer}>
      <PageTitle>{t("Select checks")}</PageTitle>
      {/* <CheckSelectionFilters onSearch={onSearch} /> */}
    </div>
  );
}

const styles = {
  headerContainer: css(
    {
      display: "flex",
      flexDirection: "column",
      gap: "var(--space-3)",
    },
    mq({
      padding: ["0", "0", "var(--space-5) var(--space-8)"],
    })
  ),
};
